import { handleActions } from 'redux-actions'
import actions from '~/actions'

const initialState = {
  data: [],
  load: false,
  period: 'last30Days'
}

const reducer = handleActions(
  {
    [actions.chart.data]: (state, { payload }) => ({
      ...state,
      data: payload
    }),
    [actions.chart.period]: (state, { payload }) => ({
      ...state,
      period: payload
    }),
    [actions.chart.load]: (state, { payload }) => ({
      ...state,

      load: payload
    }),
    [actions.chart.reset]: (state) => ({
      ...state,
      data: [],
      load: false,
      period: 'last30Days'
    })
  },
  initialState
)

export default reducer
